/**
 * Collection for all API providers
 */
const ProviderCollection = Object.freeze([
  { key: "NONE", label: "None" },
  { key: "GOLFSPAIN", label: "Golfspain" },
  { key: "SYS_GOLF", label: "SysGolf" },
  { key: "CONCEPT", label: "Concept" },
  { key: "GOLF_MANAGER", label: "Golfmanager" },
  { key: "CHRONO_GOLF", label: "Chronogolf" }
]);

export default ProviderCollection;
